export const DiaperPageBottomVideoSectionData = [
  {
    url: 'https://images.myloapp.in/NestJsUploads/1729772203266-d-3.mp4',
    title: `<b><i>@drtarunanandpedia</i></b>`,
    caption: 'MD - Pediatrics, MBBS',
    caption2: '9 Years Experience',
    viewCount: '',
    icon: 'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
    showInsta: true,
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1729772203260-a-1.mp4',
    title: `<b><i>@drirshadahmadwani</i></b>`,
    caption: 'Surgeon Consultant Gynaecologist',
    caption2: '8 Years Experience',
    viewCount: '',
    icon: 'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
    showInsta: true,
  },

  {
    url: 'https://images.myloapp.in/NestJsUploads/1729772203269-l-1.mp4',
    title: `<b><i>@nanhebaccho_ka_doctor</i></b>`,
    caption: 'MD Pediatrics',
    caption2: '8 Years Experience',
    viewCount: '',
    icon: 'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
    showInsta: true,
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1729772203267-s-1.mp4',
    title: `<b><i>@drpawan_clinic</i></b>`,
    caption: 'MBBS, DCH, DNB Pediatrics',
    caption2: '7 Years Experience',
    viewCount: '',
    icon: 'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
    showInsta: true,
  },
];
export const DiaperPageTopVideoSectionData = [
  {
    url: 'https://images.myloapp.in/NestJsUploads/1720531006665-w.mp4',
    caption: `Rash-Free Baby Diapers for My Baby`,
    viewCount: '1.3M',
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1720531006664-t.mp4',
    caption: `Best Baby Diapers for babies`,
    viewCount: '900K',
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1723801610504-1720531006666-r.mp4',
    caption: `My Baby Loves Mylo Baby Diapers`,
    viewCount: '1.2M',
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1720525230122-D.webm',
    caption: ` Ultimate Comfort with Mylo Baby Diapers `,
    viewCount: '1M',
  },
];
export const LactomamaVideoSectionData = [
  {
    url: 'https://images.myloapp.in/NestJsUploads/1731329578627-IMG_2161-1.mp4',
    title: ``,
    caption: '',
    viewCount: '1.8M',
    icon: 'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
    showInsta: false,
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1731329368549-dr.sourojitgupta-lactomama-1.mp4',
    title: ``,
    caption: '',
    viewCount: '1.2M',
    icon: 'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
    showInsta: false,
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1731329292269-rowdybabyamyra-1.mp4',
    title: ``,
    caption: '',
    viewCount: '1.5M',
    icon: 'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
    showInsta: false,
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1731499937476-LM1.mp4',
    title: ``,
    caption: '',
    viewCount: '1.1M',
    icon: 'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
    showInsta: false,
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1731499937487-lactomama-video-2.mp4',
    title: ``,
    caption: '',
    viewCount: '1.4M',
    icon: 'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
    showInsta: false,
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1731499937488-lactomama-video-1.mp4',
    title: ``,
    caption: '',
    viewCount: '1.2M',
    icon: 'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
    showInsta: false,
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1732104568670-lactomama-video-5.mp4',
    title: ``,
    caption: '',
    viewCount: '1.2M',
    icon: 'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
    showInsta: false,
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1732104590911-lactomama-video-6.mp4',
    title: ``,
    caption: '',
    viewCount: '1.2M',
    icon: 'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
    showInsta: false,
  },
];

export const ClothDiaperVideoSectionData = [
  {
    url: 'https://images.myloapp.in/NestJsUploads/1735562011729-1723610027837-A_cloth.mp4',
    username: 'shreyaa.siddhartharora',
    caption: `Sidya stays comfy all day in Mylo Cloth Diaper`,
    viewCount: '1M',
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1735562225753-1723610027836-B_Cloth.mp4',
    username: ' flying_mom_23',
    caption: `Shanaya loves the comfort of Mylo Diapers`,
    viewCount: '1.2M',
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1735562325211-1723781458698-C.mp4',
    username: 'ikabir_yadav',
    caption: `Mylo Cloth Diaper keeps Arhaan rash-free and happy`,
    viewCount: '900K',
  },
  {
    url: 'https://images.myloapp.in/NestJsUploads/1735562444096-1723610027816-D_cloth_diaper.mp4',
    username: 'suppergalviv',
    caption: `I love the prints and they are super soft`,
    viewCount: '1.3M',
  },
];
